import { SET_INVOICE } from 'redux/actions/types';
const initialState = {
  form: {},
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_INVOICE:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
